import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { isEmpty, isArray } from 'lodash';
import { Children, cloneElement } from 'react';
import classnames from 'classnames/bind';
import RadioItem from '../radioField';
import { formFieldWrapper } from '../formFieldWrapper';
import styles from './styles.scss';
import RadioButtonField from '../radioField/radioButtonField';
const cx = classnames.bind(styles);
export var BaseRadioGroupFieldVariant;
(function (BaseRadioGroupFieldVariant) {
    BaseRadioGroupFieldVariant["DEFAULT"] = "default";
    BaseRadioGroupFieldVariant["INLINE"] = "inline";
    BaseRadioGroupFieldVariant["TWO_COLUMN"] = "twoColumn";
})(BaseRadioGroupFieldVariant || (BaseRadioGroupFieldVariant = {}));
const BaseRadioGroupField = ({ options, elmId, onChange, showError, size, compact, value, children, disabled, className, inline, variant, secondary, ...rest }) => {
    const newCompact = size === 'small' ? true : compact;
    const formProps = {
        onChange,
        className: cx(className, 'radio-group', { medium: size === 'medium' }),
    };
    const childrenOptions = children ? (Children.map(children, (child, index) => {
        return cloneElement(child, {
            ...formProps,
            ...rest,
            disabled: child?.props?.disabled || disabled,
            checked: value === child?.props?.value,
            compact: newCompact,
            secondary,
            elmId: child?.props?.elmId || `${elmId}_radio_option_${index}`,
        });
    })) : (_jsx("div", {}));
    let formattedChildrenOptions;
    switch (variant) {
        case BaseRadioGroupFieldVariant.INLINE:
            formattedChildrenOptions = (_jsx("div", { className: cx('inline-options'), children: childrenOptions }));
            break;
        case BaseRadioGroupFieldVariant.TWO_COLUMN:
            formattedChildrenOptions = (_jsx("div", { className: cx('two-column-options'), children: childrenOptions }));
            break;
        default: {
            formattedChildrenOptions = inline ? (_jsx("div", { className: cx('inline-options'), children: childrenOptions })) : (childrenOptions);
        }
    }
    return (_jsx(_Fragment, { children: !isArray(options) || isEmpty(options)
            ? formattedChildrenOptions
            : options.map((option, index) => {
                return (_jsx(RadioItem, { "data-elm-id": option.elmId || `${elmId}_radio_option_${index}`, label: option.label, onChange: onChange, value: option.value || '', checked: value === option.value ||
                        (isEmpty(value) && isEmpty(option.value)), disabled: disabled || option.disabled, className: cx('radio-group', { medium: size === 'medium' }), compact: newCompact, ...rest }, `options_${index}`));
            }) }));
};
const RadioGroupField = formFieldWrapper((fieldProps, showError) => (_jsx(BaseRadioGroupField, { ...fieldProps, showError: showError })));
export const RadioButtonGroupField = ({ options, disabled, inline, elmId, name, ...rest }) => {
    return (_jsx(RadioGroupField, { elmId: elmId, disabled: disabled, name: name, inline: inline, ...rest, children: options.map((option, index) => (_createElement(RadioButtonField, { ...option, disabled: disabled || option?.disabled, key: index }))) }));
};
export default RadioGroupField;
//# sourceMappingURL=index.js.map